import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import firebase from 'firebase/app';
import dayjs from 'dayjs';

import Divider from '@mui/material/Divider';

import DateRangePickerField from '../../components/DateRangePickerField';
import ScrapFormList from './ScrapFormList';
import ContextStore from '../../modules/context';

function ScrapFormTab() {
  const { tabName } = useParams()
  const { currentUser } = useContext(ContextStore)

  const [scrapForms, setScrapForms] = useState([])
  const [startDate, setStartDate] = useState(dayjs().subtract(2, 'months').format('YYYY-MM') + '-01')
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'))

  useEffect(() => {
    if (scrapForms.length) setScrapForms([])
    const onSnapshot = snapshot => {
      const scrapForms = []
      snapshot.forEach(doc => {
        scrapForms.push({ ...doc.data(), id: doc.id })
      });
      setScrapForms(scrapForms)
    }
    const unsubscribe = tabName === 'pending' ?
      firebase.firestore().collection('scrapForms').where('status', '==', tabName).onSnapshot(onSnapshot, err => {}) :
      firebase.firestore().collection('scrapForms').where('status', '==', tabName).where('date', '>=', startDate).where('date', '<=', endDate).onSnapshot(onSnapshot, err => {})
    return () => unsubscribe()
  }, [startDate, endDate]);

  const scrapFormsForTab = scrapForms.filter(r =>
    currentUser.userRights.debugging ||
    currentUser.scrapFormSource.includes(r.source) ||
    currentUser.scrapFormReview.includes(r.source)
  );

  const reqWaitingForProcess = waitingForProcess()

  function waitingForProcess() {
    if (tabName === 'pending') {
      return scrapFormsForTab.filter(r => {
        const history = r.history || []
        const currentStep = history.length > 0 ? history[history.length - 1].step : 0
        if (isNaN(currentStep) || currentStep === r.steps.length) return false
        return r.steps[currentStep].users.includes(currentUser.key)
      })
    } else {
      return []
    }
  }

  return (
    <div style={{ paddingBottom: '60px' }}>
      {tabName !== 'pending' && <DateRangePickerField
        startDate={startDate}
        endDate={endDate}
        onStartDateChanged={setStartDate}
        onEndDateChanged={setEndDate}
      />}
      {reqWaitingForProcess.length > 0 && <>
        <ScrapFormList scrapForms={reqWaitingForProcess} title={`scrapForm.table.${tabName}.title`} />
        <Divider sx={{ mx: '0px', my: '10px' }}/>
      </>}
      <ScrapFormList scrapForms={scrapFormsForTab} title="scrapForm.table.title" />
    </div>
  );
}

export default ScrapFormTab;
